import React from 'react';
import { IonRouterOutlet } from '@ionic/react';
import { Redirect, Route } from 'react-router-dom';
import Login from './pages/Login';
import Signup from './pages/Signup';
import SignFlow from './pages/SignFlow';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AnonInvitePage from './pages/AnonInvitePage';
import ViewMenuListPage from './pages/ViewMenu/ViewMenuList';
import ViewMenuItemDetailPage from './pages/ViewMenu/ViewMenuItemDetail';
import PublicReceipt from './pages/PublicReceipt';
import VerifyCode from './pages/VerifyCode';

const AuthRoutes = () => {
  return (
    <IonRouterOutlet id="auth">
      <Route path="/auth/sign" component={SignFlow} exact />
      <Route path="/auth/login" component={Login} exact />
      <Route path="/auth/signup" component={Signup} exact />
      <Route path="/verify-code" component={VerifyCode} exact />
      <Route path="/auth/forgot-password" component={ForgotPassword} exact />
      <Route path="/auth/reset-password" component={ResetPassword} exact />
      <Route path="/receipts/:receiptId" component={PublicReceipt} exact />
      <Route
        path="/invite/:venueId/:ticketId"
        component={AnonInvitePage}
        exact
      />
      <Route
        path="/locations/:locationId/view-menu"
        component={ViewMenuListPage}
        exact
      />
      <Route
        path="/locations/:locationId/view-menu/:itemId"
        component={ViewMenuItemDetailPage}
        exact
      />
      <Route component={() => <Redirect to="/auth/sign" />} />
    </IonRouterOutlet>
  );
};

export default AuthRoutes;
